













import {
    defineComponent,
    inject,
    ref,
    computed,
    onMounted,
} from '@vue/composition-api'

// Store
import { StoreKey as FormStoreKey } from '@/store/Form'
import { StoreKey as InputStoreKey } from '@/store/Input'

// Util
import { prepareField } from '@/ts/util/field'

type Props = {
    name: string
    required: boolean | string
    requiredMessage: string
    id: string
    classname: string
    single: string | boolean
}

export default defineComponent({
    inheritAttrs: false,
    props: {
        name: { type: String, required: false },
        required: { type: [String, Boolean], required: false },
        requiredMessage: { type: String, required: false },
        id: { type: String, required: false },
        classname: { type: String, required: false },
        single: { type: [String, Boolean], default: false },
    },
    setup(props: Props) {
        const formStore = inject(FormStoreKey)
        if (!formStore) {
            throw new Error(`${FormStoreKey} is not provided`)
        }

        const inputStore = inject(InputStoreKey)
        if (!inputStore) {
            throw new Error(`${InputStoreKey} is not provided`)
        }

        const commonFn = prepareField({
            type: 'checkbox',
            name: props.name,
            inputStore,
            formStore,
        })

        const errors = ref<string[]>([])
        const target = ref<HTMLDivElement>(null)
        const updateHandler = () => {
            if (!target.value) {
                return
            }

            let value = inputStore.get_value(props.name)
            if (!value) {
                return
            } else if (!Array.isArray(value)) {
                value = [value]
            }

            const checkboxes = target.value.querySelectorAll(
                'input[type="checkbox"]'
            )
            const nodes = Array.prototype.slice.call(
                checkboxes,
                0
            ) as HTMLInputElement[]

            nodes.map((option) => {
                if (value.some((val) => option.value === val)) {
                    option.checked = true
                }
            })
        }
        onMounted(updateHandler)

        const checkedHandler = ({
            value,
            selected,
        }: {
            value: string
            selected: boolean
        }) => {
            if (!target.value) {
                return
            }

            if (props.single) {
                if (!selected) {
                    return
                }

                const checkboxes = target.value.querySelectorAll(
                    'input[type="checkbox"]'
                )
                const nodes = Array.prototype.slice.call(
                    checkboxes,
                    0
                ) as HTMLInputElement[]
                nodes.map((node) => {
                    if (node.value === value) {
                        node.checked = true
                    } else {
                        node.checked = false
                    }
                })
                inputStore.set_value(props.name, value)
            } else {
                if (!inputStore.values.hasOwnProperty(props.name)) {
                    inputStore.set_value(props.name, [])
                }

                if (selected) {
                    inputStore.set_value(props.name, [
                        ...new Set([...inputStore.values[props.name], value]),
                    ])
                } else {
                    inputStore.set_value(
                        props.name,
                        inputStore.values[props.name].filter((v) => {
                            return v !== value
                        })
                    )
                }
            }

            // バリデーション
            onValidate()
        }
        inputStore.check_emitter[props.name] = checkedHandler

        const onValidate = () => {
            // バリデーション
            let result = false
            errors.value = []
            const val = inputStore.get_value(props.name)
            if (props.required !== false) {
                if (
                    (!Array.isArray(val) && !val) ||
                    (Array.isArray(val) && !val.length)
                ) {
                    result = true
                    const message = props.requiredMessage || '入力してください'
                    errors.value.push(message)
                }
            }
            inputStore.set_error(props.name, result)
            return result
        }

        const getValidateRule = () => {
            return {
                required: props.required ? true : false,
            }
        }

        const classnames = computed(() => {
            const errors = inputStore.errors

            const result: { [key: string]: boolean } = {}
            ;(props.classname || '').split(' ').map((key) => {
                result[key] = true
            })
            result['is-invalid'] =
                errors.hasOwnProperty(props.name) && errors[props.name]

            return result
        })
        return {
            ...commonFn,
            inputStore,
            updateHandler,
            onValidate,
            getValidateRule,
            target,
            errors,
            classnames,
        }
    },
})
